import React from 'react';
import clsx from 'clsx';
import Icon from '@/components/icon/Icon';
import {
  ChecklistProps,
  SIZE_STYLES,
  ICON_SIZE,
  ICON_WRAPPER_SIZE,
  TEXT_VARIANT,
} from './types';

export const Checklist = ({
  items,
  iconName = 'check',
  size = 'md',
  variant = 'dark',
  className,
}: ChecklistProps) => {
  if (!items?.length) return null;

  const isCircle = iconName === 'circle-check';

  return (
    <ul
      className={clsx(
        'flex flex-col gap-8',
        SIZE_STYLES[size],
        TEXT_VARIANT[variant],
        className,
      )}
    >
      {items.map((item, index) => (
        <li
          key={index}
          className={clsx(
            'flex items-center gap-3',
            size === 'lg' && 'mt-8',
            size === 'md' && 'mt-6',
            size === 'sm' && 'mt-4',
          )}
        >
          <span
            aria-hidden="true"
            className={clsx(
              'flex shrink-0 items-center justify-center p-1',
              isCircle &&
                clsx(ICON_WRAPPER_SIZE[size], 'rounded-full bg-brand-400'),
            )}
          >
            <Icon
              name={iconName === 'circle-check' ? 'check' : iconName}
              size={ICON_SIZE[size]}
              strokeWidth={2}
              className={clsx(
                isCircle
                  ? 'text-white'
                  : variant === 'dark'
                    ? 'text-brand-400'
                    : 'text-brand-500',
              )}
            />
          </span>

          <span className="font-medium">{item.text}</span>
        </li>
      ))}
    </ul>
  );
};
